'use strict';

var _ = require('lodash');
var GridCopyCalendarButtonController = function GridCopyCalendarButtonController($scope, seasonalityConstants) {
  var CAL_STATUS = seasonalityConstants.CALENDAR_STATUSES;
  function isCalendarValidForCopy(calendar) {
    return calendar.calendarStatus === CAL_STATUS.FINISHED || calendar.calendarStatus === CAL_STATUS.COMPLETED;
  }
  $scope.isCopyCalendarButtonShown = false;
  $scope.onRowSelection = function (selectedRows) {
    $scope.isCopyCalendarButtonShown = selectedRows && selectedRows.length === 1 && isCalendarValidForCopy(selectedRows[0]);
  };
  $scope.callCopyFunction = function () {
    if (_.isFunction($scope.copyCalendar)) {
      $scope.copyCalendar();
    }
  };
};
GridCopyCalendarButtonController.$inject = ['$scope', 'SeasonalityConstants'];
module.exports = GridCopyCalendarButtonController;